import { render, staticRenderFns } from "./advertising1.vue?vue&type=template&id=5ce9ab70&scoped=true"
import script from "./advertising1.vue?vue&type=script&lang=js"
export * from "./advertising1.vue?vue&type=script&lang=js"
import style0 from "./advertising1.vue?vue&type=style&index=0&id=5ce9ab70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce9ab70",
  null
  
)

export default component.exports